/*
 * @Descripttion: 库存管理页面相关方法
 * @Author: 曹博
 * @Date: 2023-10-17 17:22:16
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-24 13:28:14
 */

import { useEffect, useReducer } from 'react'
import reducer, {
  State,
  initState,
  setCurrentReviseMaterialAction,
  setDataSourceAction,
  setIsReviseModalVisibleAction,
  setLoadingAction,
  setPagesAction,
  setSearchDataAction,
  setIsImportModalVisibleAction,
  setUploadFilesListAction,
  setReviseModalConfirmBtnLoadingAction,
  setOriginFileAction,
  setProjectOptionsAction,
  setAreaDataOptionsAction,
  setFlatDataOptionsAction,
  setEditLoadingAction,
} from './reducer'
import { Form, message } from 'antd'
import {
  DOWNLOAD_PRODUCT,
  GET_INVENTORYDETAIL,
  GET_PRODUCTAREA,
  GET_PROJECT,
  GET_STOCK_LIST,
  PRODUCT_STOCK_EXPORT,
  PRODUCT_STOCK_IMPORT,
  UPDATE_STOCK,
  UPDATE_STOCKSTATUS,
} from '../../api/InventoryManagementApi'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
import { isResponseCodeSuccess } from '../../tools/util'
const UseInventoryManagementHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const {
    uploadFilesList,
    originFile,
    projectOptions,
    currentReviseMaterial,
    flatDataOptions,
  } = state
  const [form] = Form.useForm()
  const [platform] = Form.useForm()
  // 搜索
  const handleSearchClick = async (params: any) => {
    dispatch(setSearchDataAction(params))
    const newParams = {
      ...state,
      searchData: {
        ...params,
      },
    }
    getData(newParams)
  }

  // 刷新
  const onRefresh = () => {
    getData(state)
  }

  // 导出
  const exportData = async () => {
    const currentProject = await platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
      platformName: projectOptions.find((item) => item.value === currentProject)
        ?.label,
    }
    const res = await PRODUCT_STOCK_EXPORT({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      message.success('开始导出，请到任务中心查看')
    }
  }

  // 导入弹窗
  const changeImportModalVisible = (val: boolean) => {
    dispatch(setIsImportModalVisibleAction(val))
    if (!val) {
      // 关闭弹窗时情况文件列表
      dispatch(setUploadFilesListAction([]))
    }
  }

  // 切换分页
  const handlePaginationChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    getData({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 获取库存数据
  const getData = async (state: State) => {
    if (!platform.getFieldValue('project')) {
      dispatch(setLoadingAction(false))
      message.warning(
        '您当前没有可以维护区域库存的项目权限，有问题请联系咸亨工作人员',
      )
      return
    }
    dispatch(setLoadingAction(true))
    const params = {
      ...state.pages,
      ...state.searchData,
    }
    const currentProject = await platform.getFieldValue('project')
    const res = await GET_STOCK_LIST({
      ...params,
      platformCode: currentProject,
    })
    dispatch(setLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const flatData = res.data.content.flatMap((item: any) => {
        if (item.areaInventoryList.length > 0) {
          return item.areaInventoryList.map((term: any) => ({
            ...item,
            ...term,
          }))
        } else {
          return item
        }
      })

      // 区域数据扁平化
      const allAreaList = res.data.content.flatMap((item: any) => {
        return item.areaInventoryList
      })

      const updatedFlatData = flatData.map((item: any) => {
        return {
          ...item,
          allAreaList: allAreaList,
        }
      })

      dispatch(
        setDataSourceAction({
          dataSource: {
            data: updatedFlatData,
            total: res.data.totalCount,
          },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 打开修改库存弹窗
  const openReviseModal = async (val: any) => {
    dispatch(setCurrentReviseMaterialAction(val))
    getArea(val)
    dispatch(setIsReviseModalVisibleAction(true))
  }

  // 取消修改库存
  const closeReviseModal = () => {
    form.resetFields()
    dispatch(setIsReviseModalVisibleAction(false))
  }

  function validateRegions(dataArray: any) {
    let totalNationalWarehouseCount = 0
    for (const data of dataArray) {
      if (
        data.regionItemList.some(
          (item: { value: string }) => item.value === '-9999',
        ) &&
        data.regionItemList.length > 1
      ) {
        return true
      }
      let nationalWarehouseCount = 0
      for (const region of data.regionItemList) {
        if (region.value === '-9999') {
          nationalWarehouseCount++
        }
      }
      totalNationalWarehouseCount += nationalWarehouseCount
    }
    if (totalNationalWarehouseCount > 1) {
      return true
    }
    return false
  }
  // 提交已修改的库存信息
  const cofirmReviseInventory = async () => {
    const formValues = await form.validateFields()
    const inventoryInformation = formValues.list.map((item: any) => {
      return {
        regionItemList: regionItemList(item.sellArea),
        inventoryAmount: item.stock,
        id: item.id || '',
        inventoryStatus: item.inventoryStatus || '1',
      }
    })
    if (validateRegions(inventoryInformation)) {
      message.warning('全国仓库存请单独配置，不能和其他区域库存合并配置')
      return
    }
    dispatch(setReviseModalConfirmBtnLoadingAction(true))
    const res = await UPDATE_STOCK({
      inventoryInformation,
      productCode: currentReviseMaterial.code,
      platformCode: platform.getFieldValue('project'),
    })
    dispatch(setReviseModalConfirmBtnLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('修改成功')
      dispatch(setIsReviseModalVisibleAction(false))
      getData(state)
    }
  }

  // 导入区域库存确认
  const cofirmImportModal = async () => {
    if (!uploadFilesList.length) {
      message.warning('请上传导入文件')
    } else {
      const params = {
        file: originFile,
        platformCode: platform.getFieldValue('project'),
      }
      const res = await PRODUCT_STOCK_IMPORT({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('开始导入，请到任务中心查看')
        changeImportModalVisible(false)
      }
    }
  }

  // 下载导入模板
  const downloadTemplate = () => {
    const currentProject = platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
    }
    DOWNLOAD_PRODUCT({ ...params })
  }

  // 修改上传的文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
  }

  // 获取源文件
  const getOriginFile = (e: RcFile) => {
    dispatch(setOriginFileAction(e))
  }

  const onSwitchChange = (checked: boolean, record: any, index: number) => {
    const inventoryStatus = checked ? '1' : '0'
    const id = record.allAreaList[index].id
    const params = { id, inventoryStatus }
    updateStockStatus(params)
  }

  const updateStockStatus = async (params: {
    id: string
    inventoryStatus: string
  }) => {
    const res = await UPDATE_STOCKSTATUS(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('修改成功')
      getData(state)
    }
  }

  // 获取编辑详情
  const getEditDetail = async (val: any) => {
    const currentProject = await platform.getFieldValue('project')
    const params = {
      productCode: val.code,
      platformCode: currentProject,
    }
    const res = await GET_INVENTORYDETAIL({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      if (res.data.length) {
        const areaList = res.data.map((item: any) => ({
          sellArea: item.regionItemList?.map(
            (node: { value: string }) => node.value,
          ),
          id: item.id,
          stock: item.inventoryAmount,
          isNewItem: true,
          inventoryStatus: item.inventoryStatus,
        }))
        form.setFieldsValue({ list: areaList })
        dispatch(setEditLoadingAction(false))
      } else {
        form.setFieldsValue({ list: [{}] })
        dispatch(setEditLoadingAction(false))
      }
    }
  }

  const getArea = async (val: any) => {
    dispatch(setEditLoadingAction(true))
    const currentProject = await platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
    }
    const res = await GET_PRODUCTAREA({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      const areaData = changeAreaData([
        { addressName: '全国仓', addressCode: '-9999', children: res.data },
      ])
      const flatData = flattenData([
        { addressName: '全国仓', addressCode: '-9999', children: res.data },
      ])
      dispatch(setAreaDataOptionsAction(areaData))
      dispatch(setFlatDataOptionsAction(flatData))
      getEditDetail(val)
    }
  }

  const changeAreaData = (data: any[]) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [] // 如果data为空或不是数组，直接返回空数组
    }
    return data.map((item) => {
      const { addressCode, addressName, children } = item
      const newItem = {
        title: addressName,
        value: addressCode,
        children,
      }
      if (children && children.length > 0) {
        newItem.children = changeAreaData(children)
      }
      return newItem
    })
  }

  // 使数组扁平化
  const flattenData = (data: any) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [] // 如果data为空或不是数组，直接返回空数组
    }
    const flattened: { addressCode: any; addressName: any }[] = []
    // 使用递归函数处理每个元素
    function flatten(item: any) {
      flattened.push({
        addressCode: item.addressCode,
        addressName: item.addressName,
      })
      if (item.children && Array.isArray(item.children)) {
        item.children.forEach((child: any) => {
          flatten(child)
        })
      }
    }
    data.forEach((item: any) => {
      flatten(item)
    })
    return flattened
  }

  // 匹配label
  const regionItemList = (areaCode: any) => {
    const Items = areaCode.map((item: string) => ({
      label: flatDataOptions.find(
        (node: { addressCode: string }) => node.addressCode === item,
      ).addressName,
      value: item,
    }))
    return Items
  }

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      const res = await GET_PROJECT()
      if (isMounted && isResponseCodeSuccess(res.code)) {
        const projectList = res.data.map((item: any) => ({
          label: item.platformName,
          value: item.platformCode,
        }))
        dispatch(setProjectOptionsAction(projectList))
        platform.setFieldsValue({ project: projectList[0]?.value })
        await getData(state)
      }
    }
    fetchData()
    return () => {
      isMounted = false
    }
  }, [])

  return {
    hookstate: state,
    form,
    platform,
    handleSearchClick,
    onRefresh,
    exportData,
    handlePaginationChange,
    openReviseModal,
    closeReviseModal,
    cofirmReviseInventory,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    changeImportModalVisible,
    getOriginFile,
    onSwitchChange,
  }
}
export default UseInventoryManagementHook
/*
 * @Descripttion: 库存管理页面相关方法
 * @Author: 曹博
 * @Date: 2023-10-17 17:22:16
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-24 13:28:14
 */

import { useEffect, useReducer } from 'react'
import reducer, {
  State,
  initState,
  setCurrentReviseMaterialAction,
  setDataSourceAction,
  setIsReviseModalVisibleAction,
  setLoadingAction,
  setPagesAction,
  setSearchDataAction,
  setIsImportModalVisibleAction,
  setUploadFilesListAction,
  setReviseModalConfirmBtnLoadingAction,
  setOriginFileAction,
  setProjectOptionsAction,
  setAreaDataOptionsAction,
  setFlatDataOptionsAction,
  setEditLoadingAction,
} from './reducer'
import { Form, message } from 'antd'
import {
  DOWNLOAD_PRODUCT,
  GET_INVENTORYDETAIL,
  GET_PRODUCTAREA,
  GET_PROJECT,
  GET_STOCK_LIST,
  PRODUCT_STOCK_EXPORT,
  PRODUCT_STOCK_IMPORT,
  UPDATE_STOCK,
  UPDATE_STOCKSTATUS,
} from '../../api/InventoryManagementApi'
import { fileFile } from '../../modules/uploadfiles/hooks'
import { RcFile } from 'antd/lib/upload'
import { isResponseCodeSuccess } from '../../tools/util'
const UseInventoryManagementHook = () => {
  const [state, dispatch] = useReducer(reducer, initState)
  const {
    uploadFilesList,
    originFile,
    projectOptions,
    currentReviseMaterial,
    flatDataOptions,
  } = state
  const [form] = Form.useForm()
  const [platform] = Form.useForm()
  // 搜索
  const handleSearchClick = async (params: any) => {
    dispatch(setSearchDataAction(params))
    const newParams = {
      ...state,
      searchData: {
        ...params,
      },
    }
    getData(newParams)
  }

  // 刷新
  const onRefresh = () => {
    getData(state)
  }

  // 导出
  const exportData = async () => {
    const currentProject = await platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
      platformName: projectOptions.find((item) => item.value === currentProject)
        ?.label,
    }
    const res = await PRODUCT_STOCK_EXPORT({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      message.success('开始导出，请到任务中心查看')
    }
  }

  // 导入弹窗
  const changeImportModalVisible = (val: boolean) => {
    dispatch(setIsImportModalVisibleAction(val))
    if (!val) {
      // 关闭弹窗时情况文件列表
      dispatch(setUploadFilesListAction([]))
    }
  }

  // 切换分页
  const handlePaginationChange = (current: number, pagesize?: number) => {
    dispatch(
      setPagesAction({
        pageNo: current,
        pageSize: pagesize,
      }),
    )
    getData({
      ...state,
      ...{
        pages: {
          pageNo: current,
          pageSize: pagesize ? pagesize : 10,
        },
      },
    })
  }

  // 获取库存数据
  const getData = async (state: State) => {
    if (!platform.getFieldValue('project')) {
      dispatch(setLoadingAction(false))
      message.warning(
        '您当前没有可以维护区域库存的项目权限，有问题请联系咸亨工作人员',
      )
      return
    }
    dispatch(setLoadingAction(true))
    const params = {
      ...state.pages,
      ...state.searchData,
    }
    const currentProject = await platform.getFieldValue('project')
    const res = await GET_STOCK_LIST({
      ...params,
      platformCode: currentProject,
    })
    dispatch(setLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      const flatData = res.data.content.flatMap((item: any) => {
        if (item.areaInventoryList.length > 0) {
          return item.areaInventoryList.map((term: any) => ({
            ...item,
            ...term,
          }))
        } else {
          return item
        }
      })

      // 区域数据扁平化
      const allAreaList = res.data.content.flatMap((item: any) => {
        return item.areaInventoryList
      })

      const updatedFlatData = flatData.map((item: any) => {
        return {
          ...item,
          allAreaList: allAreaList,
        }
      })

      dispatch(
        setDataSourceAction({
          dataSource: {
            data: updatedFlatData,
            total: res.data.totalCount,
          },
          pageNo: res.data.pageNo,
        }),
      )
    }
  }

  // 打开修改库存弹窗
  const openReviseModal = async (val: any) => {
    dispatch(setCurrentReviseMaterialAction(val))
    getArea(val)
    dispatch(setIsReviseModalVisibleAction(true))
  }

  // 取消修改库存
  const closeReviseModal = () => {
    form.resetFields()
    dispatch(setIsReviseModalVisibleAction(false))
  }

  function validateRegions(dataArray: any) {
    let totalNationalWarehouseCount = 0
    for (const data of dataArray) {
      if (
        data.regionItemList.some(
          (item: { value: string }) => item.value === '-9999',
        ) &&
        data.regionItemList.length > 1
      ) {
        return true
      }
      let nationalWarehouseCount = 0
      for (const region of data.regionItemList) {
        if (region.value === '-9999') {
          nationalWarehouseCount++
        }
      }
      totalNationalWarehouseCount += nationalWarehouseCount
    }
    if (totalNationalWarehouseCount > 1) {
      return true
    }
    return false
  }
  // 提交已修改的库存信息
  const cofirmReviseInventory = async () => {
    const formValues = await form.validateFields()
    const inventoryInformation = formValues.list.map((item: any) => {
      return {
        regionItemList: regionItemList(item.sellArea),
        inventoryAmount: item.stock,
        id: item.id || '',
        inventoryStatus: item.inventoryStatus || '1',
      }
    })
    if (validateRegions(inventoryInformation)) {
      message.warning('全国仓库存请单独配置，不能和其他区域库存合并配置')
      return
    }
    dispatch(setReviseModalConfirmBtnLoadingAction(true))
    const res = await UPDATE_STOCK({
      inventoryInformation,
      productCode: currentReviseMaterial.code,
      platformCode: platform.getFieldValue('project'),
    })
    dispatch(setReviseModalConfirmBtnLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('修改成功')
      dispatch(setIsReviseModalVisibleAction(false))
      getData(state)
    }
  }

  // 导入区域库存确认
  const cofirmImportModal = async () => {
    if (!uploadFilesList.length) {
      message.warning('请上传导入文件')
    } else {
      const params = {
        file: originFile,
        platformCode: platform.getFieldValue('project'),
      }
      const res = await PRODUCT_STOCK_IMPORT({ ...params })
      if (isResponseCodeSuccess(res.code)) {
        message.success('开始导入，请到任务中心查看')
        changeImportModalVisible(false)
      }
    }
  }

  // 下载导入模板
  const downloadTemplate = () => {
    const currentProject = platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
    }
    DOWNLOAD_PRODUCT({ ...params })
  }

  // 修改上传的文件
  const handleUploadfilesChange = (e: fileFile[]) => {
    dispatch(setUploadFilesListAction(e))
  }

  // 获取源文件
  const getOriginFile = (e: RcFile) => {
    dispatch(setOriginFileAction(e))
  }

  const onSwitchChange = (checked: boolean, record: any, index: number) => {
    const inventoryStatus = checked ? '1' : '0'
    const id = record.allAreaList[index].id
    const params = { id, inventoryStatus }
    updateStockStatus(params)
  }

  const updateStockStatus = async (params: {
    id: string
    inventoryStatus: string
  }) => {
    const res = await UPDATE_STOCKSTATUS(params)
    if (isResponseCodeSuccess(res.code)) {
      message.success('修改成功')
      getData(state)
    }
  }

  // 获取编辑详情
  const getEditDetail = async (val: any) => {
    const currentProject = await platform.getFieldValue('project')
    const params = {
      productCode: val.code,
      platformCode: currentProject,
    }
    const res = await GET_INVENTORYDETAIL({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      if (res.data.length) {
        const areaList = res.data.map((item: any) => ({
          sellArea: item.regionItemList?.map(
            (node: { value: string }) => node.value,
          ),
          id: item.id,
          stock: item.inventoryAmount,
          isNewItem: true,
          inventoryStatus: item.inventoryStatus,
        }))
        form.setFieldsValue({ list: areaList })
        dispatch(setEditLoadingAction(false))
      } else {
        form.setFieldsValue({ list: [{}] })
        dispatch(setEditLoadingAction(false))
      }
    }
  }

  const getArea = async (val: any) => {
    dispatch(setEditLoadingAction(true))
    const currentProject = await platform.getFieldValue('project')
    const params = {
      platformCode: currentProject,
    }
    const res = await GET_PRODUCTAREA({ ...params })
    if (isResponseCodeSuccess(res.code)) {
      const areaData = changeAreaData([
        { addressName: '全国仓', addressCode: '-9999', children: res.data },
      ])
      const flatData = flattenData([
        { addressName: '全国仓', addressCode: '-9999', children: res.data },
      ])
      dispatch(setAreaDataOptionsAction(areaData))
      dispatch(setFlatDataOptionsAction(flatData))
      getEditDetail(val)
    }
  }

  const changeAreaData = (data: any[]) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [] // 如果data为空或不是数组，直接返回空数组
    }
    return data.map((item) => {
      const { addressCode, addressName, children } = item
      const newItem = {
        title: addressName,
        value: addressCode,
        children,
      }
      if (children && children.length > 0) {
        newItem.children = changeAreaData(children)
      }
      return newItem
    })
  }

  // 使数组扁平化
  const flattenData = (data: any) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [] // 如果data为空或不是数组，直接返回空数组
    }
    const flattened: { addressCode: any; addressName: any }[] = []
    // 使用递归函数处理每个元素
    function flatten(item: any) {
      flattened.push({
        addressCode: item.addressCode,
        addressName: item.addressName,
      })
      if (item.children && Array.isArray(item.children)) {
        item.children.forEach((child: any) => {
          flatten(child)
        })
      }
    }
    data.forEach((item: any) => {
      flatten(item)
    })
    return flattened
  }

  // 匹配label
  const regionItemList = (areaCode: any) => {
    const Items = areaCode.map((item: string) => ({
      label: flatDataOptions.find(
        (node: { addressCode: string }) => node.addressCode === item,
      ).addressName,
      value: item,
    }))
    return Items
  }

  useEffect(() => {
    let isMounted = true
    const fetchData = async () => {
      const res = await GET_PROJECT()
      if (isMounted && isResponseCodeSuccess(res.code)) {
        const projectList = res.data.map((item: any) => ({
          label: item.platformName,
          value: item.platformCode,
        }))
        dispatch(setProjectOptionsAction(projectList))
        platform.setFieldsValue({ project: projectList[0]?.value })
        await getData(state)
      }
    }
    fetchData()
    return () => {
      isMounted = false
    }
  }, [])

  return {
    hookstate: state,
    form,
    platform,
    handleSearchClick,
    onRefresh,
    exportData,
    handlePaginationChange,
    openReviseModal,
    closeReviseModal,
    cofirmReviseInventory,
    cofirmImportModal,
    downloadTemplate,
    handleUploadfilesChange,
    changeImportModalVisible,
    getOriginFile,
    onSwitchChange,
  }
}
export default UseInventoryManagementHook
